import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Typography,
  makeStyles,
} from '@material-ui/core';


const useStyles = makeStyles((theme) => {
  return {
    text: { fontSize: 16 },
    link: {
      color: theme.palette.error.main,
      textDecoration: 'underline',
      fontWeight: 'normal !important',
      '&:hover': { color: theme.palette.error.main },
    },
  };
});

const BannedSubInfo = ({ anchorInfo }) => {
  const classes = useStyles();

  return (
    <Box
      alignItems="center"
      display="flex"
      height="100%"
      justifyContent="center"
    >
      <Box textAlign="center">
        <Typography className={classes.text}>
          Your account has been reported and you can't contact <strong>{anchorInfo && anchorInfo.username}</strong> at this time
        </Typography>
        <Typography className={classes.text}>
          For more information please contact us at{' '}
          <a
            className={`${classes.text} ${classes.link}`}
            href="mailto:support@nakednews.com"
          >
            support@nakednews.com
          </a>
        </Typography>
        <Box mt={2}>
          <Typography className={classes.text}>
            Remember that you can review our{' '}
            <Link
              className={classes.link}
              to="/terms_of_service"
            >
              Terms and Conditions
            </Link>{' '}
            at any time to ensure that your behavior does not vioalte our policy.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default BannedSubInfo;
